<p-confirmDialog></p-confirmDialog>

<div class="container-fluid">
  <div class="container-morfeo">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-container">
            <div class="title-panel">
              <h1>
                <a routerLink="/admin/assistance-v1/cases/{{ case_id }}/tickets/1">
                  {{ "Case" | translate }} #{{ case_id }}
                  {{ "of" | translate }} {{ member.name }}
                </a>
                &gt; {{ "Assistance Bills" | translate }} ({{ total }})
              </h1>
            </div>
            <div class="search-panel">
              <div class="p-4">
                <div class="row">
                  <div class="col-sm-12">
                    <button *ngIf="showCreateButton &&
                      iAm(['admin', 'assistance_admin', 'supervisor', 'operator'])
                      " class="btn btn-light btn primary-btn" (click)="startCreateBill()">
                      <i class="fa fa-plus fa-fw" aria-hidden="true"></i>
                      {{ "Create Assistance Bill" | translate }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="content-panel">
              <div class="table-responsive">
                <table class="table table-condensed table-striped" aria-label="billtable">
                  <thead>
                    <tr>
                      <th scope="col">
                        {{ 'ID' | translate }}
                      </th>
                      <th scope="col">
                        {{ "Provider" | translate }}
                      </th>
                      <th scope="col">
                        {{ "Service" | translate }}
                      </th>
                      <th scope="col">
                        {{ "Price Agreed" | translate }}
                      </th>
                      <th scope="col">
                        {{ "Price Billed" | translate }}
                      </th>
                      <th scope="col">
                        {{ "SAP Status" | translate }}
                      </th>
                      <th scope="col">
                        {{ "Date" | translate }}
                      </th>
                      <th scope="col">
                        {{ "Comments" | translate }}
                      </th>
                      <th scope="col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let bill of bills">
                      <td>
                        {{ bill.id }}
                      </td>
                      <td>
                        {{ bill.provider.id + "-" + bill.provider.name }}
                      </td>
                      <td>
                        {{ bill.service.name }}
                      </td>
                      <td>
                        <a [routerLink]="[]" (click)="showDetailBill(bill)">
                          {{ bill.provider?.currency_symbol }}
                          {{ bill.price_agreed | currencyFormat }}
                        </a>
                      </td>
                      <td>
                        {{ bill.provider?.currency_symbol }}
                        {{ bill.price_billed | currencyFormat }}
                      </td>
                      <td>
                        {{
                        assistanceBillSvc.sapStatus[bill.sap_status]
                        | translate
                        }}
                      </td>
                      <td>
                        {{
                        bill.created_time
                        | currentDate
                        : { offset: assistancecase?.country?.timezone }
                        | date: "MMM"
                        | translate
                        }}
                        {{
                        bill.created_time
                        | currentDate
                        : { offset: assistancecase?.country?.timezone }
                        | date: "d, hh:mm a"
                        | translate
                        }}
                      </td>
                      <td>
                        <table role="presentation" aria-label="billcommenttable">
                          <tbody>
                            <tr *ngFor="let billcomment of billcomments">
                              <td *ngIf="billcomment.bill_id == bill.id">
                                {{ billcomment.comment }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      <td>
                        <button title="{{ 'Comment' | translate }}" (click)="onEditComment(bill)" type="button"
                          class="btn btn-xs btn-circle-morfeo">
                          <i class="fas fa-plus text-info" aria-hidden="true"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="inline-paginator text-center w-100 mb-2">
                <p-paginator [rows]="conf.perPage" [totalRecords]="total" (onPageChange)="nextPage($event)">
                </p-paginator>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<p-dialog [(visible)]="showNewBillDialog" [responsive]="true" [modal]="true" [draggable]="false" [breakpoint]="500"
  [style]="{ position: 'absolute', 'width': '75vw' }" (onHide)="newBillForm.reset()">
  <ng-template pTemplate="header">
    <div *ngIf="status_flag == 'Create'">
    {{ "Create New Bill" | translate }}
    <a class="member-info" style="color: black; text-decoration: none">
      <i *ngIf="price && price.id" class="fa fa-info-circle pointer" (click)="billInfo.show($event)"></i>
    </a>
  </div>
    <div *ngIf="status_flag == 'Update'">
    {{ "Edit Bill" | translate }}
    <a class="member-info" style="color: black; text-decoration: none">
      <i *ngIf="selectedBill && selectedBill.id" class="fa fa-info-circle pointer" (click)="billInfo.show($event)"></i>
    </a>
  </div>
  </ng-template>
  
  
  <create-assistance-bill-form [hidden]="!plan_id" [caseId]="case_id" [planId]="plan_id" [createdBills]="createdBills"
    [disabled]="isDisabled" [country]="case_country" (create)="onBillCreate($event)" (cancelEvent)="onBillCreateCancel()"
    (onLoadPrice)="onLoadPrice($event)" #newBillForm>
  </create-assistance-bill-form>
</p-dialog>

<p-dialog [(visible)]="showDetailBillDialog" [modal]="true" [draggable]="false" [style]="{ width: '77vw' }">
  <ng-template pTemplate="header">
    
    {{ "Price Details" | translate }}
  
  </ng-template>
  
  <app-detail-assistance-bill-form *ngIf="assistance_bill" [createdBills]="createdBills"
    [caseId]="assistance_bill.case_id" [planId]="assistance_bill.case.plan.id" [disabled]="isDisabled"
    [country]="assistance_bill.case.country" [read_only]="true" #editBillForm>
  </app-detail-assistance-bill-form>
</p-dialog>

<!--  Comment Dialog   -->
<p-dialog header="{{
    'Comment Bill ?? - ??'
      | translate
        : { service: selectedServiceName, provider: selectedProviderName }
  }}" [responsive]="true" [(visible)]="showCommentDialog" [modal]="true" [blockScroll]="true"
  [style]="{ width: '40vw' }">
  <form class="form-horizontal" #form="ngForm" (ngSubmit)="onUpdateComment()">
    <div class="mb-3 row">
      <div class="form-group col-sm-12" [class.has-error]="comment.oninvalid && comment.ontouchend">
        <label class="control-label">{{ "Comment" | translate }}</label>
        <div>
          <textarea name="comment" class="form-control" rows="5" [(ngModel)]="billcomment.comment" #comment
            required></textarea>
        </div>
      </div>
    </div>
    <div class="footer-btns">
      <button type="button" class="btn secundary-btn btn secundary-btn-fw" (click)="onCancelComment()">
        {{ "Cancel" | translate }}
      </button>
      <button type="submit" class="btn primary-btn btn primary-btn-fw"
        [disabled]="form.form.invalid || form.form.pending || disabled">
        {{ "Save" | translate }}
      </button>
    </div>
  </form>
</p-dialog>

<!-- Price info -->
<p-popover #billInfo [dismissable]="true">
  <app-assistance-bill-info [setAssistancePrice]="price">
  </app-assistance-bill-info>
</p-popover>